export const TAB_SET = {
  base: '/admin/costaccounting',
  tabs: [
    { label: '東京', path: 'tokyo' },
    { label: '大連', path: 'dairen' },
  ] as const,
} as const;
